module.exports = __webpack_public_path__ + "static/img/pinpai-19.b3d497e5.png";